import React, { useEffect, useState } from "react";
import "./styles.scss";
import clsx from "clsx";
// import {
//   getPredefineOptionsList,
//   openLoader,
//   closeLoader,
// } from "../../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../../components/AdminModule/Dashboard/AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { MENTORSHIP_SESSIONS_LIST } from "../constants/ApplicationUrl";
import PhoneInput from "react-phone-input-2";
import {
  Box,
  InputBase,
  Typography,
  Grid,
  Button,
  IconButton,
  ClickAwayListener,
  Tooltip,
} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import axios from "axios";
import api from "../../common/dependencies/utils/Api";

import {
  MENTORSHIP_ENGAGEMENT_MEETING,
  MENTORSHIP_SCHEDULE_SESSION,
} from "../constants/ApplicationUrl";
import swal from "sweetalert";
import ReactSelect from "react-select";
import Link from "@material-ui/core/Link";
import * as moment from "moment";
import loaderImg from "../../../assets/images/small-loader.gif";
// import loaderImg from '../../../../../../assets/images/small-loader.gif';
const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgba(0,0,0,0.05)",
    // paddingLeft: "10px",
    minHeight: "45px",
    // borderRadius: "var(--curve10)",
    color: "#333",
    // border: "1px solid #bfc0c1",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
};
const styles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "rgba(0,0,0,0.2)",
      // backgroundColor:  isSelected &&isFocused ? "#b499c7" : "#b499c7",

      color: "#000",
    };
  },
};

const useStyles = makeStyles((theme) => ({
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
  },
  smallWidth: {
    width: "300px",
    fontWeight: "bold",
    color: "#b499c7",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
  },
  tableContainer: {
    padding: "10px",
  },
  lessPadding: {
    padding: "3px 16px",
  },
  wordCounter: {
    textAlign: "right",
    fontfamily: "Montserrat",
    fontSize: "14px",
    marginTop: "4px",
    color: "rgba(0,0,0,0.5)",
  },
  leftTitle: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#b499c7",
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "10px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  flex: {
    display: "flex",
    alignItems: "center",
  },
  backButton: {
    backgroundColor: "#fff",
    fontFamily: "Montserrat",
    color: "#3ac2d7",
    textTransform: "none",
    width: "200px",
    fontWeight: "bold",
    border: "2px solid #3ac2d7",
    transition: "0.3s",
    "&:focus": {
      color: "#3ac2d7",
      border: "2px solid #3ac2d7",
    },
    "&:hover": {
      backgroundColor: "#3ac2d7",
      color: "#fff",
    },
  },
  saveButton: {
    backgroundColor: "#fff",
    fontFamily: "Montserrat",
    color: "#3ac2d7",
    textTransform: "none",
    width: "200px",
    fontWeight: "bold",
    transition: "0.3s",
    marginLeft: "15px",
    border: "2px solid #3ac2d7",
    "&:hover": {
      backgroundColor: "#3ac2d7",
      color: "#fff",
    },
  },
  offlineButton: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    backgroundColor: "#b499c7",
    color: "#fff",
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
      backgroundColor: "#b499c7",
    },
  },
  onlineButton: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    backgroundColor: "#b499c7",
    color: "#fff",
    opacity: 0.6,
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
      backgroundColor: "#b499c7",
    },
  },
  commonInput: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "16px",
    color: "rgba(0,0,0,0.5)",
    width: "100%",
    border: "1px solid rgba(0,0,0,0.3)",
    borderRadius: "4px",
    padding: "5px 10px",
  },
  commonInput2: {
    fontFamily: "Montserrat",
    fontWeight: "500",
    fontSize: "16px",
    color: "rgba(0,0,0,0.87)",
    width: "100%",
    border: "1px solid rgba(0,0,0,0.3)",
    borderRadius: "4px",
    padding: "5px 10px",
  },
  goalLabel: {
    marginTop: "20px",
    marginBottom: "10px",
    fontSize: "14px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "rgba(0,0,0,0.4)",
  },
}));

const NumberSurface = (props) => {
  return (
    <Box
      style={{
        height: "34px",
        width: "34px",
        borderRadius: "50%",
        border: "2px solid #3ac2d7",
        display: "flex",
        justifyContent: "center",
        marginRight: "10px",
        fontSize: "16px",
        fontFamily: "Montserrat",
        alignItems: "center",
      }}
    >
      {props.content}
    </Box>
  );
};

const CustomModal = (props) => {
  const classes = useStyles();
  const [offline, setOffline] = useState(true);
  const [offlineData, setOfflineData] = useState("");
  const [meetingLink, setMeetingLink] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedMentorShip, setSelectedMentorShip] = useState("");
  const [hours, setHours] = useState("");
  const [goal1, setGoal1] = useState("");
  const [goal2, setGoal2] = useState("");
  const [goal3, setGoal3] = useState("");
  const [outcome, setOutcome] = useState("");
  const [copiedOpen, setCopiedOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [otherDetail, setOtherDetail] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [sessionMomModalOpen, setSessionMomModalOpen] = useState(false);
  const [mentorshipSessionId, setMentorshipSessionId] = useState();
  const [summarySessionData, setSummarySessionData] = useState();
  const { modalOpen } = props;
  const [directions, setDirections] = useState("");
  const [phonevalue, setPhoneValue] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("in");
  const [venue, setVenue] = useState("");
  const [address, setAddress] = useState("");
  const [phNumber, setPhNumber] = useState("");
  const [directionsError, setDirectionsError] = useState("");
  const [venueError, setVenueError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [phNumberError, setPhNumberError] = useState("");
  const [error, setError] = useState();
  const [timeError, setTimeError] = useState();
  const [isLoading, setLoading] = useState(false);
  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  useEffect(() => {
    if (props?.modalData !== undefined) {
      setDate(moment(props?.modalData?.sessionDate).format("YYYY-MM-DD"));
      setHours(moment(props?.modalData?.sessionDate).format("hh:mm A"));
    }
  }, [props.modalData]);
  const getMeeting = () => {
    // props.openLoader();
    // axios({
    //   url: MENTORSHIP_ENGAGEMENT_MEETING,
    //   method: "GET",
    // })
    api
      .GET(MENTORSHIP_ENGAGEMENT_MEETING)
      .then((res) => {
        setMeetingLink(res.data?.data);
        // props.closeLoader();
      })
      .catch((err) => {
        // props.closeLoader();
      });
  };

  useEffect(() => {
    // getMeeting();
    setOffline(true);
    setOfflineData("NA");
    setDate("");
    setTime("");
    setHours("1");
    setGoal1("");
    setGoal2("");
    setGoal3("");
    setOutcome("");
    setTouched(false);
    setSelectedUser("");
    setTimeError("");
  }, [modalOpen]);
  const apiCall = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let request = {
      mentorshipId: selectedMentorShip,
      sessionDate: date,
      sessionTime: time,
      duration: hours,
      sessionGoals: [],
      timeZone: timezone,
      venue: offlineData === "OFFLINE" ? "" :venue,
        address:offlineData === "OFFLINE" ? "" : address,
        phoneNo:offlineData === "OFFLINE" ? "" : phonevalue,
        directions:offlineData === "OFFLINE" ? "" : directions
    };
    if (outcome) {
      request.desiredOutcomes = outcome;
    }
    if (offline) {
      request.sessionFormat = "OTHER";
      request.otherDetail = otherDetail;
      request.vcUrl = "";
    } else {
      request.sessionFormat = "ONLINE";
      request.vcUrl = meetingLink;
    }
    if (goal1) {
      request.sessionGoals.push(goal1);
    }
    if (goal2) {
      request.sessionGoals.push(goal2);
    }
    if (goal3) {
      request.sessionGoals.push(goal3);
    }
    if (props.EditModalValue) request.scheduleId = props.modalData.scheduleId;
    //   props.openLoader();
    request.addedBy = localStorage.getItem("SavedLoggedInData") && loggedIn?.id;
    setLoading(true);
    // axios({
    //   url: MENTORSHIP_SCHEDULE_SESSION,
    //   method: "POST",
    //   data: request,
    // })
    api.POST(MENTORSHIP_SCHEDULE_SESSION, request).then((res) => {
      swal(
        "Success",
        props.EditModalValue
          ? "Your Session has been Edited Successfully!"
          : "Your Session Scheduled Successfully!",
        "success"
      ); //   props.closeLoader();
      // props.setDidDataChange(props.didDataChange + 1);
      // props.setParentVisibility(false);
      // props.setSessionNotesCount(false);
      // props.setCheckSessionStatus(false);
      props.setModalOpen(false);
      // if(props.EditModalValue)
      // props.openEditModal(false);
      setLoading(false); //stop loading when data is fetched
      setTimeout(() => {
        // props.setModalOpen(false);
        props.parentData(true);
        props.hideModal(true);
      }, 1500);
    });
  };
  const scheduleSessionCheck = () => {
    let data;
    // axios({
    //   url: MENTORSHIP_SESSIONS_LIST,
    //   method: "POST",
    //   data: {
    //     mentorshipId: selectedMentorShip,
    //   },
    // })
    api
      .POST(MENTORSHIP_SESSIONS_LIST, {
        mentorshipId: selectedMentorShip,
      })
      .then((res) => {
        if (res.status === 200) {
          data = res.data.data;
          let counter = 0;
          let counter2 = 0;
          let counter3 = 0;
          data.forEach((item, index) => {
            if (loggedIn?.role === "Mentor") {
              if (item.momMentorSubmitted === false) counter++; // checks startup's notes filled or not submitted
              if (item.sessionStatus !== "COMPLETED") counter2++; // checks startup's sessions are completed
              if (item.momStartupSubmitted === false) counter3++;
            } else {
              if (item.momStartupSubmitted === false) counter++; // checks startup's notes filled or not submitted
              if (item.sessionStatus !== "COMPLETED") counter2++; // checks startup's sessions are completed
              if (item.momMentorSubmitted === false) counter3++;
            }
          });
          // resolve();
          // return (res.data.data,counter,counter2,counter3)
          let ele = res.data.data?.find((ele) => {
            if (ele.sessionStatus === "SCHEDULED") {
              return true;
            }
          });
          if (ele) {
            swal(
              "Complete Existing Session",
              "Please complete or delete the existing session to schedule a new one",
              "info",
              {
                buttons: {
                  text: "OK",
                },
              }
            );
            return false;
          } else if (
            (counter === 0 && !ele && counter3 === 0) ||
            data.length <= 0
          ) {
            apiCall();
            // setModalOpen(true);
          } else {
            // swal(
            //   !(counter3 === 0) && counter === 0
            //     ? loggedIn?.role === "Mentor"
            //       ? "Startup's Session Note Not Submitted"
            //       : "Mentor's Session Note Not Submitted"
            //     : "Please Fill Session Notes",
            //     !(counter3 === 0) && counter === 0
            //     ? loggedIn?.role === "Mentor"
            //     ?  `Please wait till the ${
            //         loggedIn?.role === "Mentor" ? "Startup  " : "Mentor "
            //       } Completes their Session Notes`
            //     : "To Complete Engagement please fill Session Notes.":"",
            //   "info"
            // );
            swal(
              !(counter3 === 0) && counter === 0
                ? loggedIn?.role === "Mentor"
                  ? "Startup's Session Note Not Submitted"
                  : "Mentor's Session Note Not Submitted"
                : "Please Fill Session Notes",
              !(counter3 === 0) && counter === 0
                ? loggedIn?.role === "Mentor"
                  ? `Please wait till the ${
                      loggedIn?.role === "Mentor" ? "Startup  " : "Mentor "
                    } Completes their Session Notes`
                  : "To Complete Engagement please fill Session Notes."
                : "",

              {
                icon: "info",
                buttons:
                  !(counter3 === 0) && counter === 0
                    ? loggedIn?.role === "Mentor"
                      ? { text: "OK" }
                      : { text: "OK" }
                    : {
                        delete: {
                          text: "FILL NOW",
                        },
                        decline: {
                          text: "CANCEL",
                        },
                      },
              }
            ).then((value) => {
              if (value === "delete") {
                setMentorshipSessionId(data[0]?.mentorshipId);
                setSummarySessionData(data[data?.length - 1]);
                setSessionMomModalOpen(true);
              }
            });
            return false;
          }
        }
        setTimeout(() => {
          // props.setModalOpen(false);
          props.parentData(true);
        },1500)
      })
      .catch((err) => {
        // reject();
      });
    // return data
  };
  const handleSubmit = () => {
    if (
      (props?.EditModalValue !== undefined && props?.EditModalValue === true
        ? false
        : !offline && !meetingLink) ||
      !date ||
      !time ||
      !hours ||
      !goal1 ||
      !selectedMentorShip 
    //  || !offlineData
    ) {
      setError("Please enter all details*");
      return;
    }

    if (props.EditModalValue) {
      apiCall();
    } else {
      apiCall();
      // scheduleSessionCheck();
    } // if (props.EditModalValue) request.scheduleId = props.modalData.scheduleId;

    // when no prior sessions are scheduled
  };
  const handleClose = () => {
    props.setModalOpen(false);
    props.openEditModal(false);
  };
  useEffect(() => {
    if (props.EditModalValue) {
      setDate(moment(props?.modalData?.sessionStart).format("YYYY-MM-DD"));
      setTime(moment(props?.modalData?.sessionStart).format("HH:mm:ss"));
      setHours(props?.modalData?.sessionDuration);
      if (props?.modalData?.sessionFormat === "ONLINE") {
        setOffline(false);
        setMeetingLink(props?.modalData?.vcUrl);
      } else {
        setOffline(true);
        setMeetingLink("OFFLINE");
      }
      setGoal1(props?.modalData?.sessionGoals[0]);
      if (props?.modalData?.sessionGoals[1] !== undefined)
        setGoal2(props?.modalData?.sessionGoals[1]);
      if (props?.modalData?.sessionGoals[2] !== undefined)
        setGoal3(props?.modalData?.sessionGoals[2]);
      setOutcome(props?.modalData?.desiredOutcomes);
      setSelectedMentorShip(props?.modalData?.mentorshipId);
    }
  }, [props.EditModalValue]);
  return (
    <Modal
      size="lg"
      show={props.modalOpen}
      onHide={() => props.setModalOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      dialogClassName="mentorship_engagement_summary--modal_width"
      contentClassName="mentorship_engagement_summary--modal_content_width"
      style={{ borderRadius: "7px" }}
    >
      <Modal.Header className="d-flex justify-content-center">
        <Modal.Title className="modalHeading d-flex justify-content-center">
          SCHEDULE A SESSION
          {/* {props.EditModalValue === true
            ? "EDIT YOUR SESSION"
            : "SCHEDULE A SESSION"} */}
        </Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleClose}
        />
      </Modal.Header>
      <Modal.Body>
        <Box style={{ padding: "35px" }}>
          <Grid container spacing={3}>
            <Grid item md={4} xs={12} sm={12} className={classes.flex}>
              <NumberSurface content="1" />
              <Typography className={classes.leftTitle}>
                {loggedIn?.role === "Mentor" ? "STARTUP*" : "MENTOR*"}
              </Typography>
            </Grid>
            <Grid item container spacing={2} md={8} xs={12} sm={12}>
              <Grid item container spacing={2} md={8} sm={12} xs={12}>
                <Grid item md={7} xs={12}>
                  {props?.EditModalValue ? (
                    <div
                      style={{ whiteSpace: "nowrap", fontFamily: "Montserrat" }}
                    >
                      {loggedIn?.role === "Mentor"
                        ? props?.modalData?.startup?.applicant_name
                        : props?.modalData?.mentor?.applicant_name}
                      {}
                    </div>
                  ) : (
                    <ReactSelect
                      placeholder={
                        loggedIn?.role === "Mentor"
                          ? "Select Startup"
                          : "Select Mentor"
                      }
                      className={classes.select}
                      options={props?.sessionList}
                      onChange={(selected) => {
                        setSelectedUser(selected.value);
                        setSelectedMentorShip(selected.mentorshipId);
                      }}
                      styles={{
                        menu: (styles) => {
                          return {
                            ...styles,
                          };
                        },
                        option: (
                          styles,
                          { data, isDisabled, isFocused, isSelected }
                        ) => {
                          return {
                            ...styles,
                            backgroundColor: isSelected
                              ? "#b499c7"
                              : isFocused
                              ? "#e4d7ee"
                              : "white",
                            color: isSelected ? "white" : "black",
                            cursor: isDisabled ? "not-allowed" : "default",
                          };
                        },
                      }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={4} xs={12} className={classes.flex}>
              <NumberSurface content="2" />
              <Typography className={classes.leftTitle}>
                {"SESSION DATE & TIME*"}
              </Typography>
            </Grid>
            <Grid item container spacing={2} md={8} xs={12}>
              <Grid item md={4} xs={12}>
                <Box
                  style={{
                    border: "1px solid rgba(0,0,0,0.3)",
                    borderRadius: "4px",
                    display: "flex",
                    padding: "5px 10px",
                  }}
                >
                  <InputBase
                    inputProps={{
                      min: new Date().toISOString().slice(0, 10),
                    }}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    style={{
                      fontFamily: "Montserrat",
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "rgba(0,0,0,0.5)",
                      width: "100%",
                    }}
                    value={date}
                    onChange={(e) => {
                      setDate(e.target.value);
                      setTimeError(null);
                      setError(null);
                    }}
                  />
                </Box>
              </Grid>
              <Grid item md={4} xs={12}>
                <Box
                  style={{
                    border: "1px solid rgba(0,0,0,0.3)",
                    borderRadius: "4px",
                    display: "flex",
                    padding: "5px 10px",
                  }}
                >
                  <InputBase
                    label="hh:mm"
                    placeholder="hh:mm"
                    type="time"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    style={{
                      fontFamily: "Montserrat",
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "rgba(0,0,0,0.5)",
                      width: "100%",
                    }}
                    value={time}
                    onChange={(e) => {
                      const first = e.target.value.slice(0, 2);
                      const second = e.target.value.slice(3);
                      const curH = new Date().getHours();
                      const curM = new Date().getMinutes();
                      if (!date) {
                        setTimeError("Enter Date First");
                        return;
                      }
                      if (moment().format("YYYY-MM-DD") === date) {
                        if (parseInt(first) < parseInt(curH)) {
                          setTimeError("You cannot set a past time");
                          return;
                        } else if (parseInt(first) === parseInt(curH)) {
                          if (parseInt(second) < parseInt(curM)) {
                            setTimeError("You cannot set a past time");
                            return;
                          }
                        }
                      }
                      setTime(e.target.value);
                      setTimeError("");
                      setError(null);
                    }}
                  />
                </Box>
                {timeError && (
                  <Typography
                    variant="caption"
                    style={{ color: "red", fontFamily: "Montserrat" }}
                  >
                    {timeError}
                  </Typography>
                )}
              </Grid>
            </Grid>

            <Grid item md={4} xs={12} className={classes.flex}>
              <NumberSurface content="3" />
              <Typography className={classes.leftTitle}>
                {"SESSION DURATION(in hours) *"}
              </Typography>
            </Grid>
            <Grid item container spacing={2} xs={12} md={8}>
              <Grid item xs={12} md={4}>
                <ReactSelect
                  value={{
                    value: hours,
                    label: `${hours}`,
                  }}
                  className={classes.select}
                  options={[
                    { value: "0.5", label: "0.5 " },
                    { value: "1", label: "1 " },
                    { value: "1.5", label: "1.5 " },
                    { value: "2", label: "2 " },
                    { value: "2.5", label: "2.5 " },
                    { value: "3", label: "3 " },
                    { value: "3.5", label: "3.5 " },
                    { value: "4", label: "4 " },
                    { value: "4.5", label: "4.5 " },
                    { value: "5", label: "5 " },
                    { value: "5.5", label: "5.5 " },
                    { value: "6", label: "6 " },
                  ]}
                  onChange={(selected) => setHours(selected.value)}
                  styles={{
                    menu: (styles) => {
                      return {
                        ...styles,
                      };
                    },
                    option: (
                      styles,
                      { data, isDisabled, isFocused, isSelected }
                    ) => {
                      return {
                        ...styles,
                        backgroundColor: isSelected
                          ? "#b499c7"
                          : isFocused
                          ? "#e4d7ee"
                          : "white",
                        color: isSelected ? "white" : "black",
                        cursor: isDisabled ? "not-allowed" : "default",
                      };
                    },
                  }}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} md={4} className={classes.flex}>
              <NumberSurface content="4" />
              <Typography className={classes.leftTitle}>
                {"SESSION FORMAT*"}
              </Typography>
            </Grid>
            <Grid item container spacing={2} xs={12} md={8}>
              {props.EditModalValue !== undefined && props.EditModalValue ? (
                props?.modalData?.sessionFormat === "ONLINE" ? (
                  <div style={{ padding: "0.45rem" }}>ONLINE</div>
                ) : (
                  <div style={{ padding: "0.45rem" }}>OFFLINE</div>
                )
              ) : (
                <>
                  <Grid item xs={12} md={4}>
                    <Button
                      className={
                        offlineData === "NA"
                          ? classes.offlineButton
                          : offlineData !== "OFFLINE"
                          ? classes.offlineButton
                          : classes.onlineButton
                      }
                      variant="contained"
                      fullWidth
                      onClick={() => {
                        if (!date || !time || !hours) {
                          swal({
                            title: "Info!",
                            text: !date
                              ? "Please select Date"
                              : !time
                              ? "Please select Time"
                              : !hours
                              ? "Please Select hours"
                              : " Please Select all fields",
                            icon: "info",
                            // buttons: false,
                          });
                          return;
                        }
                        setOfflineData("ONLINE");
                        setTouched(true);
                        setOffline(false);
                        setError(null);
                        getMeeting();
                      }}
                    >
                      MAARG Platform
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button
                      className={
                        offlineData === "NA"
                          ? classes.offlineButton
                          : offlineData === "OFFLINE"
                          ? classes.offlineButton
                          : classes.onlineButton
                      }
                      fullWidth
                      variant="contained"
                      onClick={() => {
                        if (!date || !time || !hours) {
                          swal({
                            title: "Info!",
                            text: !date
                              ? "Please select Date"
                              : !time
                              ? "Please select Time"
                              : !hours
                              ? "Please Select hours"
                              : " Please Select all fields",
                            icon: "info",
                            // buttons: false,
                          });
                          return;
                        }
                        setOfflineData("OFFLINE");
                        setOffline(true);
                        setTouched(true);
                        setError(null);
                      }}
                    >
                      Other Platform
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>

            {!offline &&
              props.EditModalValue !== undefined &&
              !props.EditModalValue && (
                <>
                  <Grid item xs={12} md={4} className={classes.flex}></Grid>
                  <Grid item container spacing={2} xs={12} md={8}>
                    <Grid
                      item
                      xs={12}
                      md={8}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "-5px",
                      }}
                    >
                      <Link
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => window.open(meetingLink, "_blank")}
                      >
                        MAARG Session Link{" "}
                      </Link>
                      <ClickAwayListener
                        onClickAway={() => setCopiedOpen(false)}
                      >
                        <div>
                          <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "16px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                                Click to Copy MAARG Session Link
                              </Typography>
                            }
                          >
                            <IconButton
                              disabled={!meetingLink}
                              onClick={() => {
                                setShowToast(true);
                                setTimeout(() => {
                                  setShowToast(false);
                                }, 3000);
                                setCopiedOpen(true);
                                navigator.clipboard.writeText(meetingLink);
                              }}
                              style={{ marginLeft: "10px" }}
                            >
                              <ContentCopyIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </ClickAwayListener>
                      {showToast && (
                        <Typography
                          variant="caption"
                          style={{ fontFamily: "Montserrat", fontSize: "14px" }}
                        >
                          Copied MAARG Session Link
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={4}></Grid>
                  <Grid item xs={12} md={8}>
                    <Typography
                      style={{
                        fontFamily: "Montserrat",
                        fontSize: "13px",
                        color: "rgba(0,0,0,0.7)",
                        margin: "-13px 0px",
                      }}
                    >
                      All Chats and Video Discussions may be recorded for
                      quality purposes
                    </Typography>
                  </Grid>
                </>
              )}
               { touched && !offline   &&
                <>
                 <Grid item md={4} sm={12} className={classes.flex}>
                 <NumberSurface content="4" />
                 <Typography className={classes.leftTitle}>
                   {"VENUE"}
                 </Typography>
               </Grid>
               <Grid item container spacing={2} md={8} sm={12}>
                 <Grid item xs={12} md={8} sm={12}>
                 <InputBase
                        className={venue !== "" ? classes.commonInput2 :classes.commonInput}
                        placeholder={"Please Enter the Venue of the Meeting."}
                        fullWidth
                        onChange={(e) => {
                          setVenue(e.target.value);
                        }}
                        value={venue}
                      />
                 </Grid>
               </Grid>
               <Grid item md={4} sm={12} className={classes.flex}>
                 <NumberSurface content="5" />
                 <Typography className={classes.leftTitle}>
                   {"ADDRESS"}
                 </Typography>
               </Grid>
               <Grid item container spacing={2} md={8} sm={12}>
                 <Grid item xs={12} md={8} sm={12}>
                 <InputBase
                        className={address !== "" ? classes.commonInput2 :classes.commonInput}
                        placeholder={"Please Enter the Address of the Meeting."}
                        fullWidth
                        onChange={(e) => {
                          setAddress(e.target.value);
                        }}
                        value={address}
                      />
                 </Grid>
               </Grid>
               <Grid item md={4} sm={12} className={classes.flex}>
                 <NumberSurface content="6" />
                 <Typography className={classes.leftTitle}>
                   {"CONTACT NUMBER"}
                 </Typography>
               </Grid>
               <Grid item container spacing={2} md={8} sm={12}>
                 <Grid item xs={12} md={8} sm={12}>
                 <PhoneInput
                        country={selectedCountry}
                        value={phonevalue}
                        countryCodeEditable={false}
                        disableDropdown	={true}
                        style={{ fontSize: "15px",color:"lightgray",width:"100%",height:"100%" }}
                        onChange={(phonevalue, country) => {
                          setSelectedCountry(country.countryCode);
                          setPhoneValue(phonevalue);
                        }}
                        placeholder="Please Enter the Contact Number."
                       
                      />
                 </Grid>
               </Grid>
               <Grid item md={4} sm={12} className={classes.flex}>
                 <NumberSurface content="7" />
                 <Typography className={classes.leftTitle}>
                   {"DIRECTIONS LINK"}
                 </Typography>
               </Grid>
               <Grid item container spacing={2} md={8} sm={12}>
                 <Grid item xs={12} md={8} sm={12}>
                 <InputBase
                        value={directions}
                        className={directions !== "" ? classes.commonInput2 :classes.commonInput}
                        placeholder={
                          "Please Enter the web link for directions to the Venue."
                        }
                        fullWidth
                        onChange={(e) => {
                          setDirections(e.target.value);
                          if(e.target.value.startsWith('https://'))
                          {
                            setDirectionsError(false)
                          }
                          else{
                            setDirectionsError(true)
                          }
                        }}
                      /> 
                           {directionsError && (
                    <Typography
                      variant="caption"
                      style={{
                        color: "red",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                      }}
                    >
                      Please enter a proper google maps link.
                    </Typography>
                  )}
                 </Grid>
               </Grid>
               </> 
               }  
            {touched && offline && (
              <>
                <Grid item xs={12} md={4}></Grid>
                <Grid item xs={12} md={8}>
                  <InputBase
                    className={classes.commonInput}
                    placeholder={"Please Enter Details of Other Platform"}
                    fullWidth
                    value={otherDetail}
                    onChange={(e) => {
                      setOtherDetail(e.target.value);
                      setError(null);
                    }}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} md={4} className={classes.flex}>
              <NumberSurface content={touched && !offline ? "8": "5"} />
              <Typography className={classes.leftTitle}>
                {"SESSION GOALS (Atleast One)*"}
              </Typography>
            </Grid>
            <Grid item container spacing={2} xs={12} md={8}>
              <Grid item xs={12} md={4}>
                <Typography className={classes.goalLabel}>
                  SET GOAL 1*
                </Typography>
                <InputBase
                  className={classes.commonInput}
                  placeholder={"SET GOAL 1 (max 50 words)"}
                  value={goal1}
                  rows={6}
                  multiline
                  maxRows={6}
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                    const newerData = newData.replace(/[ ]{2,}/gi, " ");
                    if (newerData.split(" ").length <= 50) {
                      setGoal1(e.target.value);
                    }
                    setError(null);
                  }}
                />
                <Typography className={classes.wordCounter}>
                  Word Count:{" "}
                  {goal1?.length === 0
                    ? 0
                    : goal1
                        ?.replace(/(^\s*)|(\s*$)/gi, "")
                        ?.replace(/[ ]{2,}/gi, " ")
                        ?.split(" ")?.length}
                  /50
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography className={classes.goalLabel}>
                  SET GOAL 2
                </Typography>
                <InputBase
                  rows={6}
                  maxRows={6}
                  className={classes.commonInput}
                  placeholder={"SET GOAL 2 (max 50 words)"}
                  value={goal2}
                  multiline
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                    const newerData = newData.replace(/[ ]{2,}/gi, " ");
                    if (newerData.split(" ").length <= 50) {
                      setGoal2(e.target.value);
                    }
                    setError(null);
                  }}
                />
                <Typography className={classes.wordCounter}>
                  Word Count:{" "}
                  {goal2?.length === 0
                    ? 0
                    : goal2
                        ?.replace(/(^\s*)|(\s*$)/gi, "")
                        ?.replace(/[ ]{2,}/gi, " ")
                        ?.split(" ")?.length}
                  /50
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography className={classes.goalLabel}>
                  SET GOAL 3
                </Typography>
                <InputBase
                  rows={6}
                  maxRows={6}
                  className={classes.commonInput}
                  placeholder={"SET GOAL 3 (max 50 words)"}
                  value={goal3}
                  fullWidth
                  multiline
                  onChange={(e) => {
                    const value = e.target.value;
                    const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                    const newerData = newData.replace(/[ ]{2,}/gi, " ");
                    if (newerData.split(" ").length <= 50) {
                      setGoal3(e.target.value);
                    }
                    setError(null);
                  }}
                />
                <Typography className={classes.wordCounter}>
                  Word Count:{" "}
                  {goal3?.length === 0
                    ? 0
                    : goal3
                        ?.replace(/(^\s*)|(\s*$)/gi, "")
                        ?.replace(/[ ]{2,}/gi, " ")
                        ?.split(" ")?.length}
                  /50
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={12} md={4} className={classes.flex}>
              <NumberSurface content={touched && !offline ? "9" :"6"} />
              <Typography className={classes.leftTitle}>
                {"DESCRIPTION/REMARKS"}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
              <InputBase
                style={{
                  border: "1px solid rgba(0,0,0,0.3)",
                  padding: "10px",
                  fontFamily: "Montserrat",
                  borderRadius: "3px",
                  fontSize: "18px",
                }}
                rows={5}
                maxRows={5}
                value={outcome}
                onChange={(e) => {
                  const value = e.target.value;
                  const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                  const newerData = newData.replace(/[ ]{2,}/gi, " ");
                  if (newerData.split(" ").length <= 100) {
                    setOutcome(e.target.value);
                  }
                  setError(null);
                }}
                fullWidth
                multiline
                placeholder={"Enter max 100 words"}
              />
              <Typography className={classes.wordCounter}>
                Word Count:{" "}
                {outcome?.length === 0
                  ? 0
                  : outcome
                      ?.replace(/(^\s*)|(\s*$)/gi, "")
                      ?.replace(/[ ]{2,}/gi, " ")
                      ?.split(" ")?.length}
                /100
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}></Grid>
            <Grid item xs={12} md={8}>
              <Typography
                variant="body2"
                style={{ fontFamily: "Montserrat", color: "red" }}
              >
                {error}
              </Typography>
            </Grid>
          </Grid>

          <Box
            style={{
              display: "flex",
              justifyContent: "space-around",
              padding: "50px 25% 0 25% ",
            }}
          >
            <Box>
              <Button
                onClick={() => {
                  props.setModalOpen(false);
                  props.openEditModal(false);
                }}
                className={classes.backButton}
                disableRipple
              >
                BACK
              </Button>
              <Button
                onClick={handleSubmit}
                className={clsx(classes.saveButton, "saveButton55")}
                disableRipple
              >
                {"SAVE & SUBMIT"}
              </Button>
            </Box>
            {/* {isLoading && (
              <div className="loader-frame">
                <div className="loader-container">
                  <img src={loaderImg} />
                </div>
              </div>
            )} */}
          </Box>
        </Box>
      </Modal.Body>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
})(withRouter(CustomModal));
